import styled from 'styled-components';

interface IProps {
  isSelected?: boolean;
  height?: number;
  length?: number;
}

export const ImageSliderWrapper = styled.div<IProps>`
  user-select: none;
  cursor: pointer;
  flex-direction: row;
  display: flex;
  padding-left: 20px;
`;

export const ImageWrap = styled.div<IProps>`
  display: flex;
  justify-content: center;
  background-color: #000000;
  margin-right: 5px;
  border-radius: 5px;
  overflow: hidden;

  & img {
    object-fit: cover;
  }
  & .video-react-control-bar {
    background: transparent;
  }
`;
